import Model from './Model'
import Employee from './Employee'
export class SaveModelRequest {
    Model: Model;
    SavedByEmployee: Employee;
}

export default SaveModelRequest;